<template>
  <div class="container">
    <CommonFrame
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :moduleName="moduleName"
      :breadcrumb="breadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus"
      @attachmentValue='attachmentValue'
    >
      <div slot="info">
        <h4>
          <span>商品ID:</span>
          <span>{{id}}</span>
        </h4>
        <span v-for="(item,index) in titleInfo" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="formInfo">
        <div class="cardContainer" v-if="!newModified">
          <lk-card title='修改首营商品'>
              <lk-form  :label-width='134' label-position="right">
               <lk-row :gutter='16'>
                  <lk-col span='15'>
                    <lk-form-item label="变更内容:" prop='typeId' >
                      <div v-for="(i, index) in content" :key="index">
                        <span>{{i}}</span>
                      </div>
                    </lk-form-item>
                    <lk-form-item label="申请附件:" prop='typeId' >
                      <Attachment
                        :isCanEdit="false"
                        :uploadInfo='attachmentRemark.bizExtraVos'
                        @attachmentConfirm='attachmentConfirm'
                      ></Attachment>
                    </lk-form-item>
                    <lk-form-item label="修改备注:" prop='typeId' >
                      <span>{{attachmentRemark.remark}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
          </lk-card>
        </div>
        <div class="cardContainer" v-else>
          <lk-card title='新建首营商品'>
              <lk-form  :label-width='134' label-position="right">
               <lk-row :gutter='16'>
                  <lk-col>
                    <lk-form-item label="注意事项:" prop='typeId' >
                        <span>{{attentions}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
          </lk-card>
        </div>
        <div class="cardContainer">
          <lk-card title='基础商品信息'>
              <lk-form  :label-width='134' label-position="right">
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label="商品类型:" prop='typeId' >
                      <goodsTypeCascader v-model='typeId' placeholder="请选择，一旦保存将无法修改" :disabled='true'></goodsTypeCascader>
                      <!-- <lk-select v-model='typeId' placeholder="请选择，一旦保存将无法修改" >
                        <lk-option v-for='(item,index) in goodsTypes' :value='item.value'
                          :key="index">{{item.name}}</lk-option>
                      </lk-select> -->
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </lk-card>
        </div>
        <Drug  v-if='typeId===1' v-model="info.goodsBaseVO.goodsBase" :able='able' :baseData='baseData'  ref="baseInfo" :isInStore='true' ></Drug>
        <Equipment v-if='typeId===2' v-model="info.goodsBaseVO.goodsBase" :able='able' :baseData='baseData'  ref="baseInfo" :isInStore='true'  ></Equipment>
        <Decoction v-if='typeId===3' v-model="info.goodsBaseVO.goodsBase" :able='able' :baseData='baseData'  ref="baseInfo" :isInStore='true'  ></Decoction>
        <Others v-if='typeId&&![1,2,3].includes(typeId) &&info.goodsBaseVO.goodsBase' :type='typeId' v-model="info.goodsBaseVO.goodsBase" :able='able' :baseData='baseData'  ref="baseInfo" :isInStore='true'  ></Others>
        <StoreDrug  v-if='info.goodsStore&&(typeId===1)' v-model="info.goodsStore" :able='able' :baseData='baseData'  ref="storeInfo" :isInStore='true'></StoreDrug>
        <StoreEquipment v-if='typeId===2&&info.goodsStore' v-model="info.goodsStore" :able='able' :baseData='baseData'  ref="storeInfo" :isInStore='true'></StoreEquipment>
        <StoreDecoction v-if='typeId===3&&info.goodsStore' v-model="info.goodsStore" :able='able' :baseData='baseData'  ref="storeInfo" :isInStore='true'></StoreDecoction>
        <StoreOthers  v-if='![1,2,3].includes(typeId)&&info.goodsStore' v-model="info.goodsStore" :able='able' :baseData='baseData'  ref="storeInfo" :isInStore='true'></StoreOthers>

      </div>
    </CommonFrame>

  </div>
</template>

<script>
import axios from 'axios';
// import Uploader from '@/components/Uploader.vue';
import utils from '@/libs/utils';
import goods from '@/services/goods';
import Attachment from '../../../components/purchase/Attachment';
import CommonFrame from '../commonFrame.vue';
import goodsMixins from '../../../mixins/goodsMixins';
import goodsTypeCascader from '../../../components/goodsTypeCascader.vue';
// import fileUploader from '@/components/fileUploader';
import Drug from '../../../components/goods/baseGoods/Drug.vue';
import Decoction from '../../../components/goods/baseGoods/Decoction.vue';
import Equipment from '../../../components/goods/baseGoods/Equipment.vue';
import StoreDrug from '../../../components/goods/storeGoods/StoreDrug.vue';
import Others from '../../../components/goods/baseGoods/Others.vue';
import StoreOthers from '../../../components/goods/storeGoods/StoreOthers.vue';
import StoreDecoction from '../../../components/goods/storeGoods/StoreDecoction.vue';
import StoreEquipment from '../../../components/goods/storeGoods/StoreEquipment.vue';

export default {
  components: {
    // Uploader,
    // fileUploader,
    goodsTypeCascader,
    CommonFrame,
    Equipment,
    Drug,
    Decoction,
    Others,
    StoreOthers,
    StoreDrug,
    StoreEquipment,
    StoreDecoction,
    Attachment,
  },
  mixins: [goodsMixins],
  props: {
    approvalParams: {
      type: Object,
    },
  },
  computed: {


    // goodsTypes() {
    //   return this.$store.state.publicParams.goodsTypes;
    // },
    validateContentText() {
      let res = '';
      if (this.approvalStatus === 2) {
        res = '此商品在首营商品列表中已存在，正在审批中，是否前往查看？';
      } else {
        res = '此商品在首营商品列表中已存在，是否前往编辑?';
      }
      return res;
    },
  },
  data() {
    return {
      ready: true,
      businessId: null,
      typeId: null,
      goodsLabelIds: [],
      goodsLabelNames: [],
      able: false,
      showLog: false,
      logData: [],
      workNo: '',
      node: '',
      moduleName: '',
      dosageFormArr: [''],
      paymentTypeArr: [''],
      // dosageFormArr: [],
      drugMiniPackageUnitArr: [],
      storageConditionsArr: [],
      qualityOfDrugsTypeArr: [],
      preparationUnitArr: [],
      decoctionBucketArr: [],
      // approvalNumberTypeArr: [],
      periodAlertDaysArr: [],
      indicationDicString: '',
      content: [], // 变更内容
      uplodaInfo: [], // 申请附件
      remarks: '', // 备注
      attachmentRemark: {}, // 附件和备注
      newModified: '', // 控制首营是新增还是修改
      attentions: '', // 新增首营文案
      // fileList: [],

      isImportArr: ['', '是', '否'],
      // decoctionBucketArr: ['', '是', '否'],
      curingStandardArr: ['', '一般养护', '重点养护'],
      isMedicalArr: ['', '是', '否'],
      isDataLinkArr: ['', '是', '否'],

      breadcrumb: [
        {
          name: 'work',
          title: '审批管理',
        },
        {
          name: 'approvalEdit',
          title: '首营商品审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      id: '',
      idText: '',
      info: {
        goodsBaseVO: {
          goodsBase: {
            approvalNumber: '',
            approvedDrugNames: '',
            goodsName: '',
            specifications: '',
          },
        },
      },

      titleInfo: [],
      baseData: {
        dosageFormArr: [],
        drugMiniPackageUnitArr: [],
        storageConditionsArr: [],
        qualityOfDrugsTypeArr: [],
        preparationUnitArr: [],
        decoctionBucketArr: [],
        approvalNumberTypeArr: [],
        locations: [],
        indicationTree: null,
        taxRateList: this.$store.state.publicParams.taxRateList,
        label: {
          gspArr: [],
          bizArr: [],
          prodArr: [],
          otherArr: [],

        },
      },
    };
  },

  methods: {
    // setMnemonicCode(name) {
    //   console.log(name);
    //   name && supplier.mnemonicCode({ name }).then((res) => {
    //     if (res.data.status === 200) {
    //       const { data } = res.data;
    //       this.$set(this.info.goodsStore, 'mnemonicCode', data);
    //       // this.info.goodsStore.mnemonicCode = res.data.data;
    //     } else {
    //       this.$Message.error(res.data.error);
    //     }
    //   }).catch((err) => {
    //     utils.handleError(err);
    //   });
    // },
    formatLabel(data, setData) {
      if (setData) {
        data.goodsBase.gspIdList = data.gspIdList;
        data.goodsBase.bizIdList = data.bizIdList;
        data.goodsBase.drugBizIdList = data.drugBizIdList;
        data.goodsBase.drugProdIdList = data.drugProdIdList;
        data.goodsBase.otherIdList = data.otherIdList;
        data.goodsBase.equipmentIdList = data.equipmentIdList;
        data.goodsBase.gsps = data.gsps;
        data.goodsBase.bizs = data.bizs;
        data.goodsBase.prods = data.prods;
        data.goodsBase.others = data.others;
        data.goodsBase.drugMiniPackageUnitString = data.drugMiniPackageUnitString;
        data.goodsBase.indicationDicString = data.indicationDicString;
        data.goodsBase.storageConditionsStringNew = data.storageConditionsString;
        data.goodsBase.dosageFormString = data.dosageFormString;
        data.goodsBase.preparationUnitString = data.preparationUnitString;
      } else {
        data.gspIdList = data.goodsBase.gspIdList;
        data.drugBizIdList = data.goodsBase.drugBizIdList;
        data.drugProdIdList = data.goodsBase.drugProdIdList;
        data.otherIdList = data.goodsBase.otherIdList;
        data.equipmentIdList = data.goodsBase.equipmentIdList;
      }
    },
    getInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          // data.goodsBaseVO.goodsBase.approvalNumber = data.goodsBaseVO.goodsBase.approvalNumber.replace(
          //   utils.exchangeDictionary(this.baseData.approvalNumberTypeArr, data.goodsBaseVO.goodsBase.approvalNumberType), '',
          // );
          this.formatLabel(data.goodsBaseVO, true);
          // result.goodsStore = utils.deepClone(data.goodsStore);
          this.typeId = Number.parseInt(data.goodsBaseVO.goodsBase.type, 0);
          if (this.typeId === 1) {
            const { result, typeStr } = this.handleGoodsApprovalType(this.approvalNumberTypeArr, data.goodsBaseVO.goodsBase.approvalNumber);
            data.goodsBaseVO.goodsBase.approvalNumber = result;
            data.goodsBaseVO.goodsBase.approvalNumberType = typeStr;
          }
          // debugger;
          // data.goodsBaseVO.goodsBase.minTemp = Number.parseFloat(data.goodsBaseVO.goodsBase.minTemp, 0);
          // data.goodsBaseVO.goodsBase.maxTemp = Number.parseFloat(data.goodsBaseVO.goodsBase.maxTemp, 0);

          this.info = utils.deepClone(data);
          // this.$set(this, 'info', utils.deepClone(result));
          // this.info.goodsStore = ;
          this.idText = '商品ID';
          // this.goodsForm.goodsBaseVO.goodsLabelIds = data.goodsBaseVO.goodsLabelIds;

          this.id = data.goodsBaseVO.goodsBase.drugSerialCode;
          // const disableBuildTime=data.goodsStore.approvalStatus===1
          // console.log(data);
          this.businessId = data.goodsStore.id;
          this.titleInfo = [
            { name: '商品通用名', value: data.goodsBaseVO.goodsBase.approvedDrugNames },
            { name: '创建人', value: data.goodsStore.createUserName },
            { name: '创建时间', value: data.goodsStore.createTime ? utils.exchangeTimeToSecond(data.goodsStore.createTime) : '' },
            { name: '建档时间', value: data.goodsStore.buildTime ? utils.exchangeTimeToSecond(data.goodsStore.buildTime) : '' },
            { name: '申请单号', value: data.goodsStore.applyCode },
            { name: '修改人', value: data.goodsStore.modifiedUserName },
            { name: '最后修改时间', value: data.goodsStore.modifiedTime ? utils.exchangeTimeToSecond(data.goodsStore.modifiedTime) : '' },
          ];
          this.newModified = !!data.attentions;
          this.attentions = data.attentions;
        } else {
          this.$Message.error(res.data.error);
        }
        this.ready = true;
      }).catch((err) => {
        utils.handleError(err);
      });
    },


    getSelectArrs() {
      return new Promise((resolve) => {
        this.baseData.decoctionBucketArr = [];
        this.baseData.drugMiniPackageUnitArr = [];
        this.baseData.storageConditionsArr = [];
        this.baseData.qualityOfDrugsTypeArr = [];
        this.baseData.dosageFormArr = [];
        this.baseData.preparationUnitArr = [];
        this.baseData.approvalNumberTypeArr = this.approvalNumberTypeArr;
        this.baseData.periodAlertDaysArr = [];
        this.baseData.paymentTypeArr = [];
        goods.GoodsDictionary().then((res) => {
          if (res.data.status === 200) {
            res.data.data.forEach((item) => {
              switch (item.dictionaryType) {
                case 1:
                  this.baseData.dosageFormArr.push(item);
                  break;
                case 2:
                  this.baseData.decoctionBucketArr.push(item);

                  break;
                case 3:
                  this.baseData.drugMiniPackageUnitArr.push(item);

                  break;
                case 7:
                  this.baseData.paymentTypeArr.push(item);

                  break;
                case 8:
                  this.baseData.qualityOfDrugsTypeArr.push(item);

                  break;
                case 9:
                  this.baseData.storageConditionsArr.push(item);

                  break;
                case 10:
                  this.baseData.periodAlertDaysArr.push(item);
                  break;
                case 11:
                  this.baseData.preparationUnitArr.push(item);
                  break;
                // case 12:
                //   this.baseData.approvalNumberTypeArr.push(item);
                //   break;
                default:
                  break;
              }
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getRecord() {
      this.$store.commit('setDisableLoading', true);

      goods.getStoreRecord({ id: this.$route.params.businessId }).then((res) => {
        if (res.data.status === 200) {
          const records = res.data.data;
          // 参考数据是符合workNo的数据或最后一条数据
          const workNoIndex = records.findIndex(item => item.operateList && item.operateList[0].workNo === this.workNo);
          const referenceDataIndex = workNoIndex === -1 ? records.length : workNoIndex; // 参考数据索引
          const reversRecords = [];
          records.slice(0, referenceDataIndex).forEach(item => reversRecords.unshift(item));
          const reverseIndex = reversRecords.findIndex(item => item.type === 3); // 参考数据最近的type === 3的数据索引
          const modifyData = reversRecords.slice(0, reverseIndex).find(item => item.type === 2); // 两个type === 3数据中间type === 2的数据为修改内容, 修改内容可能为空
          if (modifyData) {
            modifyData.operateList.forEach((subitem) => {
              if (subitem.content) {
                subitem.content = subitem.content.substring(0, subitem.content.length - 2);
                subitem.content = subitem.content.slice(3);
                this.content.push(`${subitem.content} - 原内容:${subitem.oldValue} | 新内容:${subitem.newValue}`);
              }
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    attachmentValue(v) {
      this.attachmentRemark = v;
    },
    attachmentConfirm(val) {
      this.uploadInfo = val;
    },
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;
    this.getSelectArrs().then(() => {
      this.getInfo(this.approvalParams.businessUrl);
    });
    this.getRecord();
  },
};
</script>

<style scoped>
  .cardContainer {
    margin-bottom: 16px;
  }
  .record{
  font-size: 14px;
  padding: 0 10px;
  line-height: 2
}
.records{
  max-height: 60vh;
  overflow: auto
}
</style>
